import { AxiosResponse } from "axios";
import axios from "@/api";
import {
  BirthHomeResponse,
  HomePageResponse,
  onBoardUserAttr,
  PreconceptionHomeResponse,
  PregnancyHomeResponse,
} from "@/components/PageHome/api/interface";
import { fetchArticles } from "@/components/ArticleComponent/api";

export const fetchHomePageAPI: () => Promise<AxiosResponse<HomePageResponse>> = async () => {
  return axios.get("/home-page?populate=deep,5");
};

export const onBoardUserAPI: (
  payload: onBoardUserAttr
) => Promise<AxiosResponse<PreconceptionHomeResponse | PregnancyHomeResponse | BirthHomeResponse>> = async (
  payload
) => {
  return axios.post("/custom-home-route?populate=deep,5", payload);
};

export const fetchArticlesAPI: (slug: string) => Promise<any> = async (slug) => {
  return fetchArticles({ categorySlug: slug });
};
